import Checkbox from 'Shared/components/Checkbox'

export default function ColorCodeOption ({ field, onChange }) {
  return (
    <div className="field-editor-row">
      <div className='field-editor-input'>
        <Checkbox
          label="Colour code (show in green or red depending on whether completed or not)"
          checked={field?.config?.colorCodeBoolean}
          onChange={(e) => onChange({ config: { ...field?.config, colorCodeBoolean: e.target.checked } })}
        />
      </div>
    </div>
  )
}
